import React, { ReactElement, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import { Context } from '@/components/Context'
import serverConfig from '@/server-config'
import AirdropCard from '@/components/airdrop/AirdropCard'
import { ArtState } from '@/database/types'

axios.defaults.baseURL = serverConfig.baseURL

const ListingOverview = (): ReactElement => {
    const { auctionDataList } = useContext(Context)
    const [recentData, setRecentData] = useState<ArtData[]>([])

    useEffect(() => {
        const latestData = [...auctionDataList]
            .sort((a, b) => {
                // Convert to Date objects if not already, and handle potential null/undefined
                const dateA = new Date(a.art.createdAt ?? 0) // Fallback to epoch if undefined/null
                const dateB = new Date(b.art.createdAt ?? 0) // Fallback to epoch if undefined/null

                // Compare the timestamps
                return dateB.getTime() - dateA.getTime()
            })
            .slice(0, 20)
        setRecentData(latestData)
    }, [auctionDataList])

    const filteredArt = (artDataList: ArtData[]) =>
        artDataList.filter((artData) => {
            if (artData.art.state === ArtState.FORCED_AUCTION) {
                return true
            }
        })

    return (
        <div>
            <div className="container">
                <div>
                    <div className="prompts">
                        <ul>
                            {filteredArt(recentData).map((art, index) => (
                                <div key={art.art.id}>
                                    <h2>#{index + 1}</h2>
                                    <AirdropCard artData={art} />
                                </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListingOverview
